import { API } from '../Api';

// "Bình chọn bằng donate": streamer đưa phương án, người xem donate cho phương án mình
// muốn. Hết giờ phương án nhiều Ca nhất thắng và streamer làm theo.
// Ca đã donate thuộc về creator dù phương án thắng hay thua — KHÔNG hoàn.

export interface DonatePollOption {
  id: string;
  label: string;
  totalAmount: number;
  percent: number;
  isLeading: boolean;
}

export interface DonatePoll {
  exists: boolean;
  question: string;
  isActive: boolean;
  endAt: string | null;
  secondsLeft: number;
  isEnded: boolean;
  totalAmount: number;
  options: DonatePollOption[];
}

export interface SaveDonatePollBody {
  question: string;
  durationMinutes: number;
  isActive: boolean;
  options: string[];
  /** Mở đợt mới: đặt lại mốc tính phiếu (phiếu đợt cũ không còn tính). */
  startNewRound?: boolean;
}

export const getMyDonatePoll = () =>
  API.get<DonatePoll>('/v1/payment-service/donate-poll/me').then((r) => r.data);

export const saveDonatePoll = (body: SaveDonatePollBody) =>
  API.post<DonatePoll>('/v1/payment-service/donate-poll', body).then((r) => r.data);

export const voteDonatePoll = (
  creatorUserId: string,
  optionId: string,
  amount: number
) =>
  API.post<DonatePoll>('/v1/payment-service/donate-poll/vote', {
    creatorUserId,
    optionId,
    amount,
  }).then((r) => r.data);

// Công khai — người xem và overlay OBS đọc được không cần đăng nhập.
export const getPublicDonatePoll = (userId: string) =>
  API.get<DonatePoll>('/v1/payment-service/public/creator-donate-poll', {
    params: { userId },
  }).then((r) => r.data);
